// src/components/Appointment.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL;

const Appointment = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [submissionMessage, setSubmissionMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is authenticated
    const token = localStorage.getItem('token');
    if (!token) {
      // If not authenticated, redirect to login page
      navigate('/login', { state: { from: '/appointment' }, replace: true });
      return;
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionMessage('');

    if (!name.trim() || !phone.trim() || !message.trim()) {
      setSubmissionMessage('All fields are required.');
      return;
    }

    try {
      const token = localStorage.getItem('token'); // Get token for the request
      await axios.post(`${API_BASE}/api/appointments`, { name, phone, message }, {
        headers: { Authorization: `Bearer ${token}` }, // Attach token to header
        withCredentials: true,
      });
      setSubmissionMessage('✅ Appointment request submitted successfully! We will contact you soon.');
      setName('');
      setPhone('');
      setMessage('');
    } catch (err) {
      console.error('Appointment submission failed:', err.response?.data || err.message);
      if (err.response?.status === 401 || err.response?.status === 403) {
        setSubmissionMessage('❌ Submission failed. Please log in to book an appointment.');
      } else {
        setSubmissionMessage('❌ Appointment submission failed. Please try again.');
      }
    }
  };

  // If not authenticated, the useEffect will handle the redirect, so we don't render the form
  if (!localStorage.getItem('token')) {
    return null;
  }

  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-cyan-600 to-blue-800 font-inter text-white">
      <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-md bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white/20">
        <h2 className="text-3xl font-bold mb-6 text-center text-white">Book an Appointment</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-white text-sm font-bold mb-2" htmlFor="name">
              Your Name
            </label>
            <input
              type="text"
              id="name"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white/20 border-white/30 placeholder-gray-300"
              required
            />
          </div>
          <div>
            <label className="block text-white text-sm font-bold mb-2" htmlFor="phone">
              Phone Number
            </label>
            <input
              type="tel"
              id="phone"
              placeholder="Enter your phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white/20 border-white/30 placeholder-gray-300"
              required
            />
          </div>
          <div>
            <label className="block text-white text-sm font-bold mb-2" htmlFor="message">
              Message/Details
            </label>
            <textarea
              id="message"
              placeholder="Tell us about your painting needs..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white/20 border-white/30 placeholder-gray-300"
              rows="5"
              required
            ></textarea>
          </div>
          <button
            type="submit"
            className="bg-white text-cyan-700 font-bold py-2 px-4 rounded-full w-full hover:bg-gray-200 transition duration-300"
          >
            Book Appointment
          </button>
        </form>
        {submissionMessage && (
          <p className={`mt-4 text-center ${submissionMessage.startsWith('✅') ? 'text-green-300' : 'text-red-300'}`}>
            {submissionMessage}
          </p>
        )}
      </div>
    </div>
  );
};

export default Appointment;